import VoiceRecorder from "../VoiceRecorder";
import { Label } from "../ui/label";

export function SectionShell({ eyebrow, title, children, voiceSection, onVoice }) {
  return (
    <div className="bg-white border border-navy/10 p-8 md:p-10">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="eyebrow text-gold">{eyebrow}</div>
          <h2 className="font-display text-3xl text-navy mt-2">{title}</h2>
          <div className="w-10 h-[2px] bg-gold mt-4 mb-8" />
        </div>
        {voiceSection && onVoice && (
          <VoiceRecorder
            compact
            onUpload={(blob) => onVoice(blob, voiceSection)}
          />
        )}
      </div>
      {children}
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <div className="space-y-2">
      <Label className="text-navy text-sm font-medium">{label}</Label>
      {children}
      {hint && <p className="text-xs text-navy/50">{hint}</p>}
    </div>
  );
}
